import * as types from '../../../constants/authConstants';
import { push, replace } from 'react-router-redux';
import * as APIS from './authApi2';
import loginUrl from 'utils/url/loginUrl';
import {TRACK_EVENT} from '../../../reducers/analyticsReducer';
import { MixPanelEvents } from '../../../constants/mixpanel';
import {loginOtpTypeUrl} from "../../../utils/url/loginOtpTypeUrl";
import MixpanelService from '../../../services/mixpanel';
import {datadogRum} from "@datadog/browser-rum";
import {otpSuccessDelayTime} from "../../../constants/contants";

const LOG_IN = loginUrl();

export function loginReset() {
  localStorage.removeItem('loginData');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  return {
    type: types.LOGIN_RESET,
  };
}

export function loginOtpTypeReset() {
  return {
    type: types.LOGIN_OTP_TYPE_RESET,
  };
}


export function loginUserCheckUp(loginData, user) {
  return {
    type: types.LOGIN_CHECKUP,
    payload: {
      loginData,
      token: loginData.access_token,
      user
    }
  };
}

export function setStatusText(statusText) {
  return {
    type: types.UPDATE_STATUS_TEXT,
    payload: statusText
  };
}

export function logout() {
  localStorage.removeItem('loginData');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  return {
    type: types.LOGOUT_USER
  };
}

function getErrorStatus(error) {
  if (!error.response) {
    return 500;
  }

  return error.response.status;
}

function getErrorMessage(error) {
  if (!error.response) {
    return 'Error, please try again.';
  }

  if (error.response.data.code === 'Password Expired') {
    return 'Your token has expired.';
  }

  return error.response.data.message || error.response.data.error_description;
}

export function trackUserSession(){
  return {
    type: TRACK_EVENT,
    payload: {
      event: MixPanelEvents.webSession
    }
  };
}

function verifyLoginOtpRequest() {
  return {
    type: types.VERIFY_OTP_LOGIN_REQUEST,
    payload: {
    }
  };
}

function verifyLoginOtpSuccess(loginData, user) {
  localStorage.setItem('loginData', JSON.stringify(loginData || ''));
  localStorage.setItem('token', loginData.access_token);
  localStorage.setItem('user', JSON.stringify(user || ''));
  return {
    type: types.VERIFY_OTP_LOGIN_REQUEST_SUCCESS,
    payload: {
      loginData,
      token: loginData.access_token,
      user
    }
  };
}

function verifyLoginOtpFail(error) {
  return {
    type: types.VERIFY_OTP_LOGIN_REQUEST_FAILURE,
    payload: {
      error,
    }
  };
}

export function verifyLoginOtp(verificationCode, otpType, token) {
  return function (dispatch) {
    dispatch(verifyLoginOtpRequest());

    return APIS.verifyLoginOtp(verificationCode, otpType, token)
      .then(async response => {
        datadogRum.addUserAction('Login verifyLogin Otp success', {});
        MixpanelService.track('OTP login', {step: 'verify otp success'} );
        const user = await APIS.getCurrentUser(response.data.token.access_token);
        dispatch(verifyLoginOtpSuccess({...response.data.token, date: Date.now() }, user));
        setTimeout(() => {
          dispatch(push('/'));
        }, otpSuccessDelayTime);
      })
      .catch(error => {
        datadogRum.addUserAction('Login verifyLogin Otp failed', { error });
        MixpanelService.track('OTP login', {step: 'verify otp failed'} );
        dispatch(verifyLoginOtpFail(error.response && error.response.data));
      });
  };
}

export function loginOtpFocusAfterFail() {
  return {
    type: types.LOGIN_OTP_FOCUS_AFTER_FAIL,
  };
}


function sendOtpTypeLoginRequest(otpType) {
  return {
    type: types.OTP_TYPE_LOGIN_REQUEST,
    payload: {
      otpType,
    }
  };
}

function sendOtpTypeLoginSuccess() {
  return {
    type: types.OTP_TYPE_LOGIN_REQUEST_SUCCESS,
    payload: {
    }
  };
}

function sendOtpTypeLoginFail(error) {
  return {
    type: types.OTP_TYPE_LOGIN_REQUEST_FAILURE,
    payload: {
      error,
    }
  };
}

export function loginSendOtpType(otpType, token) {
  return function (dispatch) {
    dispatch(sendOtpTypeLoginRequest(otpType));

    return APIS.otpTypeLoginRequest(otpType, token)
      .then(() => {
        datadogRum.addUserAction('Login OTP type send success', {});
        MixpanelService.track('OTP login', {step: 'otp type send success'});
        dispatch(sendOtpTypeLoginSuccess());
      })
      .catch(error => {
        datadogRum.addUserAction('Login OTP type send failed', { error });
        MixpanelService.track('OTP login', {step: 'otp type send failed'});
        dispatch(sendOtpTypeLoginFail(error.response.data));
      });
  };
}

function loginUserRequest() {
  return {
    type: types.LOGIN_USER_REQUEST,
  };
}

function loginRequestSuccess(firstName, phoneLast4Digits, token) {
  return {
    type: types.LOGIN_REQUEST_SUCCESS,
    payload: {
      firstName,
      phoneLast4Digits,
      loginRequestToken: token,
    }
  };
}

function loginUserRequestFailure(error) {
  return {
    type: types.LOGIN_REQUEST_FAILURE,
    payload: {
      status: getErrorStatus(error),
      statusText: getErrorMessage(error)
    }
  };
}

export function loginUser(email, password) {
  return function (dispatch) {
    const userNameType = 'EMAIL';
    dispatch(loginUserRequest());

    return APIS.loginRequest(email, password, userNameType)
      .then(async (response) => {
        if (response.data && response.data.loginType === 'BASIC_AUTH') {
          const user = await APIS.getCurrentUser(response.data.token.access_token);
          datadogRum.addUserAction('Login with BASIC_AUTH success', {});
          MixpanelService.track('OTP login', {step: 'straight login success'});
          dispatch(verifyLoginOtpSuccess({...response.data.token, date: Date.now() }, user));
          dispatch(push('/'));
        } else {
          dispatch(loginRequestSuccess(
            response.data.additionalInfo.firstName,
            response.data.additionalInfo.phoneLast4Digits,
            response.data.token.access_token
          ));
          datadogRum.addUserAction('Login request success', {});
          MixpanelService.track('OTP login', {step: 'start login success'});
          dispatch(replace((loginOtpTypeUrl())));
        }
      })
      .catch(error => {
        // todo: map error
        dispatch(loginUserRequestFailure(error));
        datadogRum.addUserAction('Login request fail', {});
        MixpanelService.track('OTP login', {step: 'start login failed'});
      });
  };
}

export function loginWithRefreshToken(refreshToken, elapsedHours) {
  return function (dispatch) {
    dispatch(loginUserRequest());
    return APIS.loginWithRefreshToken(refreshToken)
      .then(async (loginData) => {
        const user = await APIS.getCurrentUser(loginData.access_token);
        dispatch(verifyLoginOtpSuccess({...loginData, date: Date.now()}, user));
        dispatch(trackUserSession());
      })
      .catch(error => { //  when token become invalid (401) the middleware at resource util will catch the error (instance*.interceptors.response)
        datadogRum.addUserAction('loginWithRefreshToken fail', { error, elapsedHours });
        MixpanelService.reset();
        dispatch(push(LOG_IN));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/auth/authWithOtp/authActions2.js